import { useEffect } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import Logo from '../images/logo.webp';
import { FiPhoneCall } from "react-icons/fi";
import { TfiEmail } from "react-icons/tfi";
import { FaFacebook, FaInstagramSquare, FaTwitter } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { fetchSettings } from '../Redux/actions/settingsActions';


const Header = () => {
  // ************ CMS START************
  const dispatch = useDispatch();
  const { settings } = useSelector(state => state.settings);
  useEffect(() => {
    dispatch(fetchSettings());
  }, [dispatch]);
  const phone_text = settings.find(setting => setting.name === 'phone_text');
  const phone_link = settings.find(setting => setting.name === 'phone_link');
  const email_link = settings.find(setting => setting.name === 'email_link');

  // const website_logo = settings.find(setting => setting.name === 'website_logo');
  // const baseImageUrl = process.env.REACT_APP_IMAGE_BASE_URL + '/';
  // const Logo = website_logo?.value ? `${baseImageUrl}${website_logo.value}` : '';

  const facebook_link = settings.find(setting => setting.name === 'facebook_link');
  const instagram_link = settings.find(setting => setting.name === 'instagram_link');
  const twitter_link = settings.find(setting => setting.name === 'twitter_link');
  // ************ CMS END************
  return (
    <>
      <section className='top_header'>
        <Container>
          <div className="">
            <div className="top_header_content">
              <ul>
                <li><FiPhoneCall /> <Link to={phone_link?.value}>{phone_text?.value}</Link></li>
                <li><TfiEmail /> <Link to={email_link?.value}>Email Us</Link></li>
              </ul>
              <ul className='social_icons'>
                <li><a href={facebook_link?.value} target="_blank" rel="noopener noreferrer"><FaFacebook /></a></li>
                <li><a href={instagram_link?.value} target="_blank" rel="noopener noreferrer"><FaInstagramSquare /></a></li>
                <li><a href={twitter_link?.value} target="_blank" rel="noopener noreferrer"><FaTwitter /></a></li>
              </ul>
            </div>
          </div>
        </Container>
      </section>
      <header className='main_header'>
        <Navbar collapseOnSelect expand="xl" >
          <Container fluid className='header-container'>
            <Navbar.Brand href="/" className='navbar-logo'><img src={Logo} alt="Brand logo" /></Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav" className='main-nav'>
              <Nav className='main_navbar'>
                <NavLink to='/' className='nav_link'>Home</NavLink>
                <NavLink to='about' className='nav_link'>About Us</NavLink>
                <NavLink to="/form/wedding" className='nav_link'>Wedding Insurance</NavLink>
                <NavLink to="/form/special-events" className='nav_link'>Special Events</NavLink>
                <NavLink to="/form/entertainment" className='nav_link'>Entertainment</NavLink>
                <NavLink to="/form/sports" className='nav_link'>Sports</NavLink>
                <NavLink to="/form/vendor" className='nav_link'>Vendors</NavLink>
                <NavLink to="/form/partners" className='nav_link'>Partners</NavLink>
              </Nav>
              <Nav className='main_navbar2'>
              </Nav>
              <button className='custom_btn'>
                <NavLink to='/form-links'> get started</NavLink>
              </button>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>
    </>
  )
}

export default Header


